import { Button, Group, Text } from '@mantine/core';
import ModalPopupComponent from 'components/ModalPopup';
import React from 'react';
import { HiOutlineLogout } from 'react-icons/hi';

interface ModalConfirmationProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ModalLogout: React.FC<ModalConfirmationProps> = ({
  opened,
  onClose,
  onConfirm,
  isLoading
}) => {
  return (
    <ModalPopupComponent title='Logout' size='lg' opened={opened} close={onClose}>
      <Text>Are you sure want to logout?</Text>
      <Group justify='flex-end' mt={'md'}>
        <Button variant='outline' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          color={'destructive'}
          loading={isLoading}
          leftSection={<HiOutlineLogout />}
          disabled={isLoading}
          onClick={onConfirm}
        >
          Logout
        </Button>
      </Group>
    </ModalPopupComponent>
  );
};

export default ModalLogout;
